// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================
    Component styles on page load
    ====================== */

.Card_card__V3KLs {
    background-color: var(--color-106);
    border: 1px solid var(--color-109);
    border-radius: 4px;
    margin: 15px 0;
}

.Card_footer__q2NFO {
    box-shadow: inset 0 1px 0 0 var(--color-116);
}

.Card_lightRuler__xgrFT {
    border-top: 1px solid var(--color-133);
}

.Card_drawer__zclxz {
    border-top: 1px solid var(--color-109);
}

.Card_largePadding__9iEHd {
    padding: 16px;
}

.Card_mediumPadding__PeJgx {
    padding: 12px;
}

.Card_smallPadding__ef1lu {
    padding: 8px;
}

.Card_noPadding__Hfeom {
    padding: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Card/Card.module.css"],"names":[],"mappings":"AAAA;;4BAE4B;;AAE5B;IACI,kCAAkC;IAClC,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd","sourcesContent":["/*  ======================\n    Component styles on page load\n    ====================== */\n\n.card {\n    background-color: var(--color-106);\n    border: 1px solid var(--color-109);\n    border-radius: 4px;\n    margin: 15px 0;\n}\n\n.footer {\n    box-shadow: inset 0 1px 0 0 var(--color-116);\n}\n\n.lightRuler {\n    border-top: 1px solid var(--color-133);\n}\n\n.drawer {\n    border-top: 1px solid var(--color-109);\n}\n\n.largePadding {\n    padding: 16px;\n}\n\n.mediumPadding {\n    padding: 12px;\n}\n\n.smallPadding {\n    padding: 8px;\n}\n\n.noPadding {\n    padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Card_card__V3KLs`,
	"footer": `Card_footer__q2NFO`,
	"lightRuler": `Card_lightRuler__xgrFT`,
	"drawer": `Card_drawer__zclxz`,
	"largePadding": `Card_largePadding__9iEHd`,
	"mediumPadding": `Card_mediumPadding__PeJgx`,
	"smallPadding": `Card_smallPadding__ef1lu`,
	"noPadding": `Card_noPadding__Hfeom`
};
export default ___CSS_LOADER_EXPORT___;
